import { IoSearch } from "react-icons/io5";


const LocationSearch = ({ setSearchTerm, placeholder }) => {
    const searchChange = (e) => {
        setSearchTerm(e.target.value);
    }
    return (
        <>
            <form id="locationSearch" onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                    <input
                        type="search"
                        placeholder={`${placeholder}`}
                        onChange={searchChange}
                    />
                    <button className="" type="submit"><IoSearch /></button>
                </div>
            </form>
        </>
    )
}


export {
    LocationSearch
}